import Vue from 'vue'
import App from './App.vue'
import './mixin'
import router from './router'
Vue.config.productionTip = false
import VueLazyload from "vue-lazyload";
//或者自定义配置插件
Vue.use(VueLazyload, {
error: require('@/assets/404.jpg'),
loading: require('@/assets/loading-spin.svg'),
attempt: 1
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
